import { MouseEventHandler } from 'react';
import { IconName, Toggle, ToggleProps } from '@ets/design-system';

type EditorIconButtonProps = {
  icon: IconName;
  disabled?: boolean;
  onClick?: MouseEventHandler<HTMLSpanElement>;
  onToggle?: ToggleProps['onToggle'];
  id?: string;
  testId: string;
};

const EditorIconButton = ({
  icon,
  disabled,
  onClick,
  onToggle,
  id,
  testId,
}: EditorIconButtonProps) => (
  <Toggle
    size="m"
    variant="link"
    disabled={disabled}
    iconProps={{ icon }}
    onClick={onClick}
    onToggle={onToggle}
    id={id}
    testId={testId}
  />
);

export default EditorIconButton;
